import React from 'react';
import PropTypes from 'prop-types';

import RatioContainer from 'components/consumer/RatioContainer';
import Placeholder from 'components/consumer/Placeholder';
import usePDPPhotos from 'data-hooks/usePDPPhotos';
import usePDPBasicDetails from 'components/consumer/PDP/state/context/usePDPBasicDetails';
import useModularPDPPhotos from 'data-hooks/useModularPDPPhotos';
import usePDPViewGalleryImageEvent from 'data-hooks/useEvents/usePDPViewGalleryImageEvent';
import usePDPCylindoViewer from 'data-hooks/usePDPCylindoViewer';
import SuspenseWithLoader from 'components/consumer/SuspenseWithLoader';
import usePdpSelectedCustomizerTab from 'components/consumer/PDP/state/pdpSelectedCustomizerTab/usePdpSelectedCustomizerTab';
import PDPDesktopMarxentConfigurator from 'components/consumer/modular-configurator/PDPMarxentConfigurator';
import PDPMobileConfigurationPhotoGalleryUI from './PDPMobileConfigurationPhotoGalleryUI';

const PDPMobileConfigurationPhotoGalleryInner = ({
  slug,
  isEditOrder = false,
  pdpIsModularBYOProduct = false,
  marxentPostHogFlag = false,
  hideMarxent = true,
  unavailableFabric = false,
}) => {
  const {
    loading: photosLoading,
    error: photosError,
    data: photosData,
  } = usePDPPhotos(null, slug);

  const {
    loading: basicDetailsLoading,
    error: basicDetailsError,
    data: basicDetailsData,
  } = usePDPBasicDetails();

  const pdpSelectedCustomizerTab = usePdpSelectedCustomizerTab();

  let modularPhotosData = useModularPDPPhotos(null, slug);

  if (!pdpIsModularBYOProduct) {
    modularPhotosData = null;
  }

  const {
    cylindoFeatures,
    isCylindoAvailable,
    loading: cylindoLoading,
    shouldShowDimensionThumbnail,
    upholsteryKey,
  } = usePDPCylindoViewer();

  const { viewGalleryImageEvent } = usePDPViewGalleryImageEvent();

  if (
    photosLoading ||
    cylindoLoading ||
    basicDetailsLoading ||
    (pdpIsModularBYOProduct && modularPhotosData.loading)
  ) {
    return (
      <RatioContainer>
        <Placeholder type="rect" loading />
      </RatioContainer>
    );
  }

  if (photosError || basicDetailsError) {
    return null;
  }

  const {
    configurationPhotos,
    isConfigFlipped,
    enableCrops,
  } = pdpIsModularBYOProduct ? modularPhotosData.data : photosData;

  const { name } = basicDetailsData;

  if (!configurationPhotos.length) {
    return null;
  }

  return marxentPostHogFlag === 'test' && pdpIsModularBYOProduct ? (
    <PDPDesktopMarxentConfigurator
      pdpIsModularBYOProduct={pdpIsModularBYOProduct}
      slug={slug}
      key={slug}
      hideMarxent={hideMarxent}
      unavailableFabric={unavailableFabric}
    />
  ) : (
    <PDPMobileConfigurationPhotoGalleryUI
      cylindoFeatures={cylindoFeatures}
      enableCrops={enableCrops}
      isConfigFlipped={isConfigFlipped}
      isCylindoAvailable={isCylindoAvailable}
      isEditOrder={isEditOrder}
      photos={configurationPhotos}
      productName={name}
      showDecideLaterOverlay={pdpSelectedCustomizerTab === 'decide-later'}
      viewGalleryImageEvent={viewGalleryImageEvent}
      shouldShowDimensionThumbnail={shouldShowDimensionThumbnail}
      upholsteryKey={upholsteryKey}
    />
  );
};

PDPMobileConfigurationPhotoGalleryInner.propTypes = {
  pdpIsModularBYOProduct: PropTypes.bool,
  isEditOrder: PropTypes.bool,
  slug: PropTypes.string,
};

const PDPMobileConfigurationPhotoGallery = props => (
  <SuspenseWithLoader
    fallback={
      <RatioContainer>
        <Placeholder type="rect" loading />
      </RatioContainer>
    }
  >
    <PDPMobileConfigurationPhotoGalleryInner {...props} />
  </SuspenseWithLoader>
);

export default PDPMobileConfigurationPhotoGallery;
